import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4fe9185e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScreenElement = _resolveComponent("ScreenElement")

  return (_openBlock(), _createBlock("div", {
    class: "screen-slide",
    style: _ctx.preview === 'preview'?{
      width: '100%',
      height: '100%',
    }:{
      width: _ctx.VIEWPORT_SIZE + 'px',
      height: _ctx.VIEWPORT_SIZE * _ctx.viewportRatio + 'px',
      top: 0,
      left: 0,
      transform: `scale(${_ctx.scale})`,
    }
  }, [
    _createVNode("div", {
      class: "background",
      style: { ..._ctx.backgroundStyle }
    }, null, 4),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slide.elements, (element, index) => {
      return (_openBlock(), _createBlock(_component_ScreenElement, {
        key: element.id,
        elementInfo: element,
        elementIndex: index + 1,
        animationIndex: _ctx.animationIndex
      }, null, 8, ["elementInfo", "elementIndex", "animationIndex"]))
    }), 128))
  ], 4))
})